import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';

function ScheduleReport() {
    const userID = sessionStorage.getItem("TRCUserId");
    const location = useLocation();

    const [scheduleId, setScheduleId] = useState('');
    const [clientData, setClientData] = useState('');
    const [employeeData, setEmployeeData] = useState('');
    const [schedule, setSchedule] = useState('');
    
    const [updatedStatus, setUpdatedStatus] = useState('Pending');
    const [remark, setRemark] = useState("");
    const [report, setReport]=useState({});
    const [scheduleType, setScheduleType] = useState('Call');

    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(param);
    };
    
    useEffect(() => {
        const orderid = getQueryParam('id');
        setScheduleId(orderid);
    }, [userID]);

    const handleStatusChange = (e) => {
        setUpdatedStatus(e.target.value);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "remarks") setRemark(value);
        // if (name === "date") setNextUpdate(value);
    };

    const handleTypeChange = (e) => {
        setScheduleType(e.target.value);
    };

    const fetchHistory=async()=>{
        try {
            const response = await axios.post(
                'https://api.trucoo.in/marketing/report/',
                {
                    scheduleId: scheduleId,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-KEY': 'erpTrucoo'
                    }
                }
            );
           
            if (response.status === 200 && response.data.status === 'success') {
                setReport(response.data.data.scheduleHistory);
                setSchedule(response.data.data);
                setClientData(response.data.data.clientData);
                setEmployeeData(response.data.data.employeeData);
            } else {
                
            }
        } catch (error) {
            console.error("Error :", error);
            alert("An error occurred ");
        }

    }
    useEffect(()=>{
        fetchHistory();

    },[scheduleId]);


    const updateStatus = async (e) => {
        e.preventDefault();
    
        if (!navigator.geolocation) {
            alert("Geolocation is not supported by your browser.");
            return;
        }
    
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const { latitude, longitude } = position.coords;
                const senData = {
                    scheduleId: scheduleId,
                    newStatus: updatedStatus,
                    updatedBy: userID,
                    clientId: clientData.id,
                    // nextUpdate: nextUpdate,
                    remark: remark,
                    type: scheduleType,
                    latitude: latitude,
                    longitude: longitude
                }

        
    
            try {
                const response = await axios.post(
                    'https://api.trucoo.in/marketing/update-schedules/',
        
                    senData,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'X-API-KEY': 'erpTrucoo'
                        }
                    }
                );
    
                if (response.status === 200 && response.data.status === 'success') {
                    alert("Status updated successfully");
                    setSchedule((prev) => ({ ...prev, status: updatedStatus, type: scheduleType }));
                    fetchHistory();
                } else {
                    alert("Failed to update status");
                }
            } catch (error) {
                console.error("Error updating status:", error);
                alert("An error occurred while updating status");
            }
        }, (error) => {
            console.error("Error getting location:", error);
            console.error("Geolocation Error Code:", error.code);  // Logs error code
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    alert("Location access denied. Please enable location services permissions.");
                    break;
                case error.POSITION_UNAVAILABLE:
                    alert("Unable to retrieve your location. Please check if your device has a GPS signal or location services is On.");
                    break;
                case error.TIMEOUT:
                    alert("Location request timed out. Please try again.");
                    break;
                default:
                    alert("Your browser is not supported for location services.");
                    break;
            }
        });
    };
    

    return (
        <>
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                <h4 className="box-title">Schedule Report</h4>
                                <p className="mb-0 box-subtitle">Schedule Details</p>
                            </div>
                            <div className="box-body">
                                <div className="row">
                                    {/* Client Details */}
                                    <div className="col-lg-6 mt-2">
                                        <div style={{ border: '1px solid #333', borderRadius: '10px', padding: '10px 15px' }}>
                                            <h5>Client Details</h5>
                                            <p><b>Name:</b> {clientData.name}</p>
                                            <p><b>Company:</b> {clientData.companyName}</p>
                                            <p><b>Location:</b> {clientData.location}</p>
                                            <p><b>Email:</b> {clientData.email}</p>
                                            <p><b>Phone:</b> {clientData.phone}</p>
                                        </div>
                                    </div>

                                    {/* Employee Details */}
                                    <div className="col-lg-6 mt-2">
                                        <div style={{ border: '1px solid #333', borderRadius: '10px', padding: '10px 15px' }}>
                                            <h5>Employee Details</h5>
                                            <p><b>Name:</b> {employeeData.employeeName}</p>
                                            <p><b>Position:</b> {employeeData.position}</p>
                                            <p><b>Email:</b> {employeeData.employeeEmail}</p>
                                        </div>
                                    </div>

                                    {/* Schedule Details */}
                                    <div className="col-lg-6 mt-2">
                                        <div style={{ border: '1px solid #333', borderRadius: '10px', padding: '10px 15px' }}>
                                            <h5>Schedule Details</h5>
                                            <p><b>Type:</b> {schedule.type}</p>
                                            <p><b>Remarks:</b> {schedule.remarks}</p>
                                            <p><b>Date:</b> {schedule.date}</p>
                                            <p><b>Status:</b> {schedule.status}</p>
                                        </div>
                                    </div>

                                    {/* Status Update Form */}
                                    <div className="col-lg-6 mt-2">
                                        <form onSubmit={updateStatus}>
                                            <label className="form-label mt-2">Schedule Type</label>
                                            <select className="form-control" value={scheduleType} onChange={handleTypeChange} required>
                                                <option value="Call">Call</option>
                                                <option value="Visit">Visit</option>
                                            </select>
                                            <label className="form-label mt-2">Remarks</label>
                                            <textarea className="form-control" rows="4" name="remarks" value={remark} onChange={handleChange} ></textarea>
                                            <label className="form-label mt-2">Update Status</label>
                                            <select className="form-control" value={updatedStatus} onChange={handleStatusChange} required>
                                                <option value="Pending">Pending</option>
                                                <option value="Completed">Completed</option>
                                                <option value="Cancelled">Cancelled</option>
                                            </select>
                                            <button type="submit" className="btn btn-primary w-100 mt-2" disabled={schedule.status === "Completed"}> Update</button>
                                        </form>
                                        <button onClick={() => window.location.href = `/client-neworder?id=${schedule.clientId}`} className="btn btn-primary w-100 mt-2">
                                         Order
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="box-header with-border">
                                <p class="mb-0 box-subtitle">Schedule Update</p>
                                </div>
                                <div class="box-body">
                                <div class="table-responsive">
                                    <table id="example" class="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                                    <thead>
                                    <tr class="text-dark">
                                        <th>Date</th>
                                        {/* <th>Old Status</th> */}
                                        <th> Status</th>
                                        <th>Type</th>
                                        <th>Remarks</th>
                
                
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {report?.length > 0 ? report?.map((reports, index) =>
                                            <tr key={index}>
                                            <td class="text-dark">{reports.date}</td>
                                            <td>{reports.newStatus}</td>
                                            <td>{reports.type}</td>
                                            <td>{reports.remark}</td>
                
                                            </tr>
                                        ):(
                                            <tr>
                                                <td colSpan={6}>No Update</td>
                                            </tr>
                                        )}
              
                                    </tbody>  
                                </table>
                                </div>              
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <Footer />
        </>
    );
}

export default ScheduleReport;
